import React, { useEffect, useState, useCallback } from 'react';
import {
  Container, Typography, TextField, MenuItem, Button, Grid, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Paper, Pagination, Alert
} from '@mui/material';
import axios from '../api/axios';

const AdminTransactionDashboard = () => {
  const [transactions, setTransactions] = useState([]);
  const [filters, setFilters] = useState({ status: '', sender_name: '' });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [error, setError] = useState(null);

  const limit = 10;

  const fetchTransactions = useCallback(async () => {
    try {
      const params = {
        page,
        limit,
        ...filters
      };
      const res = await axios.get('/transactions', { params });
      setTransactions(res.data.transactions);
      setTotalPages(res.data.metadata.totalPages);
      setError(null);
    } catch (err) {
      setError('Failed to fetch transactions');
    }
  }, [page, filters]);

  useEffect(() => {
    fetchTransactions();
  }, [fetchTransactions]);

  const handleFilterChange = (e) => {
    setFilters(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1); // Reset to first page
  };

  return (
    <Container>
      <Typography variant="h4" sx={{ my: 3 }}>
        Admin Transaction Dashboard
      </Typography>

      {error && <Alert severity="error">{error}</Alert>}

      <form onSubmit={handleSearch}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              label="Sender Name"
              name="sender_name"
              value={filters.sender_name}
              onChange={handleFilterChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Status"
              name="status"
              select
              value={filters.status}
              onChange={handleFilterChange}
              fullWidth
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="paid">Paid</MenuItem>
              <MenuItem value="cancelled">Cancelled</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={4}>
            <Button type="submit" variant="contained" fullWidth>
              Search
            </Button>
          </Grid>
        </Grid>
      </form>

      <TableContainer component={Paper} sx={{ my: 4 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#ID</TableCell>
              <TableCell>Sender</TableCell>
              <TableCell>Receiver</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Created At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.map(tx => (
              <TableRow key={tx.id}>
                <TableCell>{tx.id}</TableCell>
                <TableCell>{tx.sender_name}</TableCell>
                <TableCell>{tx.receiver_name}</TableCell>
                <TableCell>{tx.amount} {tx.currency}</TableCell>
                <TableCell>{tx.status}</TableCell>
                <TableCell>{new Date(tx.created_at).toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination
        count={totalPages}
        page={page}
        onChange={(e, value) => setPage(value)}
        color="primary"
      />
    </Container>
  );
};

export default AdminTransactionDashboard;
